"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppInfo = void 0;
var AppInfo = /** @class */ (function () {
    function AppInfo() {
        this.application = process.env.PROJECT_NAME || 'unknown';
        this.mcsRunEnv = this.ensureMcsRunEnv();
        this.version = this.ensureVersion();
        var _a = window.screen, width = _a.width, height = _a.height, availWidth = _a.availWidth, availHeight = _a.availHeight;
        this.screenSize = width + "/" + height;
        this.availableScreenSize = availWidth + "/" + availHeight;
        this.href = window.location.href;
        this.logBaseUrl = this.ensureLogBaseUrl();
    }
    AppInfo.prototype.ensureMcsRunEnv = function () {
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (!window._cianConfig) {
                return 'unknown';
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var config = window._cianConfig[this.application];
            if (!config) {
                return 'unknown';
            }
            var mcsRunEnv = searchInConfig(config, 'mcsRunEnv');
            return mcsRunEnv || 'unknown';
        }
        catch (error) {
            console.error(error);
            return 'unknown';
        }
    };
    AppInfo.prototype.ensureVersion = function () {
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (!window._cianConfig) {
                return 'unknown';
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var config = window._cianConfig[this.application];
            if (!config) {
                return 'unknown';
            }
            var version = searchInConfig(config, 'version');
            return version || 'unknown';
        }
        catch (error) {
            console.error(error);
            return 'unknown';
        }
    };
    AppInfo.prototype.ensureLogBaseUrl = function () {
        var _a;
        /**
         * Данный fallback необходим, так как есть сервисы, которые не используют @cian/web,
         * а разработчик может забыть установить переменную
         */
        if (!window._cianSystemLogger) {
            return 'https://www.cian.ru/ajax/log-error/';
        }
        return ((_a = window._cianSystemLogger[this.application]) === null || _a === void 0 ? void 0 : _a.logBaseUrl) || window._cianSystemLogger.v2.logBaseUrl;
    };
    return AppInfo;
}());
exports.AppInfo = AppInfo;
function searchInConfig(config, target) {
    var _a;
    return (_a = config.find(function (_a) {
        var key = _a.key;
        return key === target;
    })) === null || _a === void 0 ? void 0 : _a.value;
}
//# sourceMappingURL=AppInfo.js.map